import CustomerProfile from './CustomerProfile.jsx'

export default CustomerProfile
